<template>
  <sc-form
    class="box is-paddingless"
    :form="form"
    :rules="rules">
    <template
      slot="fields"
      slot-scope="{ fields }">
      <sc-field
        label="Importar arquivo"
        prop="file">
        <sc-files-upload
          ref="fileImporterField"
          v-bind="fileImporterOptions"
          @addfilestart="file => fields.file = file"
          @removefile="() => fields.file = null"/>
      </sc-field>
      <div>
        <p><strong><sc-icon icon="question-circle"/> Quais colunas meu arquivo Excel precisa ter?</strong></p>
        <p>
          Para baixar um arquivo de exemplo,
          <a
            href="/static/examples/arquivo_exemplo_tag_xml_cte.xlsx"
            download>
            <strong>clique aqui</strong>
          </a>
        </p>
      </div>
    </template>
  </sc-form>
</template>

<script>
  import {
    ScForm,
    ScField,
    ScFilesUpload,
    ScIcon,
    ScToast,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';
  import { Auth } from '@intelipost-js/secure-providers';

  const { mapState, mapActions } = createNamespacedHelpers('order/orderImporter');

  export default {
    name: 'sc-file-import',
    data() {
      return {
        rules: {
          file: [
            {
              type: ['object', 'null'],
              required: true,
              validator(rule, value, callback, fields) {
                const errors = [];
                const file = (fields.file && fields.file.file) ? fields.file.file : null;

                if (!file) {
                  errors.push(new Error('Selecione um arquivo para importar', rule.field));
                  callback(errors);
                }

                if (!(file instanceof File)) {
                  errors.push(new Error('Selecione um arquivo válido para importar', rule.field));
                  callback(errors);
                }

                callback([]);
              },
            },
          ],
        },
        acceptFiles: [
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'text/comma-separated-values',
          'text/csv',
          'application/csv',
          'application/excel',
          'application/vnd.msexcel',
          'text/anytext',
          '.xlsx',
          '.csv',
        ].join(','),
      };
    },
    computed: {
      ...mapState([
        'form',
      ]),
      fileImporterOptions() {
        const headers = {
          token: Auth.getUser().token,
          production: Auth.getUser().is_production,
        };

        return {
          name: 'importOrderExcel',
          class: 'column',
          maxFileSize: '5MB',
          labelIdle: 'Arraste e solte ou clique para importar seus arquivos (.xls/.xlsx)',
          acceptedFileTypes: this.acceptFiles,
          files: this.getFileData(),
          server: {
            url: process.env.API_URL,
            process: {
              // url: endpoint,
              headers,
              onload: () => {
                this.getFilesImport();
                ScToast.success('Arquivo importado com sucesso!');
              },
            },
          },
        };
      },
    },
    methods: {
      ...mapActions([
        'getFilesImport',
      ]),
      getFileData() {
        const { file = null } = this.form;
        const formData = new FormData();

        return (file && file.file)
          ? [formData.append('importOrderExcel', file.file, file.file.name)]
          : [];
      },
    },
    components: {
      ScForm,
      ScField,
      ScFilesUpload,
      ScIcon,
      ScToast,
    },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/components/sc-file-import/ScFileImport.vue?fdab0cf8